<div class="search-wrapper">
    <div class="input-group">
        <input type="text"
               class="form-control h-auto"
               [(ngModel)]="key"
               (keyup.enter)="search()"
               (input)="onSearchChange()"
               [ngModelOptions]="{standalone: true}"
               id="search"
               placeholder="{{'Search within these results' | translate}}"
               [attr.aria-label]="'Search within these results' | translate">
        <div class="input-group-append">
            <button (click)="search()" class="btn search-btn app-btn-search" type="button" attr.aria-label="{{'Submit Search'|translate}}">
                <i class="sli-magnifier"></i>
            </button>
        </div>
    </div>
</div>
